"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ConfigSelectors = require("pricing-pages-unified-ui/selectors/ConfigSelectors");

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

/**
 * A wrapper for Loadable that will pass common props from a common prop hook
 * to both the loading and loaded component
 *
 * @param componentLoader The loader for the full component
 * @param componentProps Props to be passed to the loading and loaded component
 * @param ComponentLoadingState The component for the loading state
 * @param useCommonComponentProps A hook to transform componentProps into any calculated props that will be needed
 * for both the loading and loaded component.
 */
var LoadableWrapper = function LoadableWrapper(_ref) {
  var componentLoader = _ref.componentLoader,
      componentProps = _ref.componentProps,
      ComponentLoadingState = _ref.ComponentLoadingState,
      useCommonComponentProps = _ref.useCommonComponentProps,
      errorMessage = _ref.errorMessage;
  var commonProps = useCommonComponentProps(componentProps);
  var ComponentLoadable = (0, _react.useMemo)(function () {
    return (0, _Loadable.default)({
      loader: componentLoader,
      LoadingComponent: function LoadingComponent() {
        return ComponentLoadingState ? _react.default.createElement(ComponentLoadingState, Object.assign({}, componentProps, commonProps)) : null;
      },
      ErrorComponent: function ErrorComponent() {
        throw new Error(errorMessage);
      }
    });
  }, []);
  return _react.default.createElement(ComponentLoadable, Object.assign({}, componentProps, commonProps));
}; // Code splits between an authed component and a public component
// Takes in a loader so we can do the code splitting inside this function.
// See LoadableWrapper above for what the props here mean


var CodeSplitEnvWrapper = function CodeSplitEnvWrapper(_ref2) {
  var _ref2$authedComponent = _ref2.authedComponentLoader,
      authedComponentLoader = _ref2$authedComponent === void 0 ? null : _ref2$authedComponent,
      _ref2$authedComponent2 = _ref2.authedComponentProps,
      authedComponentProps = _ref2$authedComponent2 === void 0 ? {} : _ref2$authedComponent2,
      authedComponentLoadingState = _ref2.authedComponentLoadingState,
      _ref2$useCommonAuthed = _ref2.useCommonAuthedProps,
      useCommonAuthedProps = _ref2$useCommonAuthed === void 0 ? function () {
    return {};
  } : _ref2$useCommonAuthed,
      _ref2$publicComponent = _ref2.publicComponentLoader,
      publicComponentLoader = _ref2$publicComponent === void 0 ? null : _ref2$publicComponent,
      _ref2$publicComponent2 = _ref2.publicComponentProps,
      publicComponentProps = _ref2$publicComponent2 === void 0 ? {} : _ref2$publicComponent2,
      publicComponentLoadingState = _ref2.publicComponentLoadingState,
      _ref2$useCommonPublic = _ref2.useCommonPublicProps,
      useCommonPublicProps = _ref2$useCommonPublic === void 0 ? function () {
    return {};
  } : _ref2$useCommonPublic;
  var isAppAuth = (0, _reactRedux.useSelector)(_ConfigSelectors.isAppAuthSelector);
  var hasNoComponentForEnv = isAppAuth && !authedComponentLoader || !isAppAuth && !publicComponentLoader;
  if (hasNoComponentForEnv) return null;
  return _react.default.createElement(LoadableWrapper, {
    componentLoader: isAppAuth ? authedComponentLoader : publicComponentLoader,
    componentProps: isAppAuth ? authedComponentProps : publicComponentProps,
    useCommonComponentProps: isAppAuth ? useCommonAuthedProps : useCommonPublicProps,
    ComponentLoadingState: isAppAuth ? authedComponentLoadingState : publicComponentLoadingState,
    errorMessage: "EnvironmentWrapper " + (isAppAuth ? 'authed' : 'public') + " component Loadable error"
  });
};

CodeSplitEnvWrapper.propTypes = {
  // https://product.hubteam.com/docs/crm-handbook/practices/code-splitting.html#creating-a-chunk-with-dynamic-import
  // () => import(/* webpackChunkName: "authed-chunk" */  'path/to/component')
  authedComponentLoader: _propTypes.default.func,
  // () => import(/* webpackChunkName: "public-chunk" */  'path/to/component')
  publicComponentLoader: _propTypes.default.func,
  authedComponentProps: _propTypes.default.object,
  publicComponentProps: _propTypes.default.object,
  publicComponentLoadingState: _propTypes.default.func,
  authedComponentLoadingState: _propTypes.default.func,
  useCommonAuthedProps: _propTypes.default.func,
  useCommonPublicProps: _propTypes.default.func
};
var _default = CodeSplitEnvWrapper;
exports.default = _default;
module.exports = exports.default;